import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { LoadingOverlay, Stack } from '@mantine/core';

import { useAvailabilityPageAccess } from '@/hooks/useAvailabilityAccess';
import { HEADER_HEIGHT, ROUTES } from '@/constants';

type AvailabilityPermissionRouteProps = {
  children: ReactNode;
};

const AvailabilityPermissionRoute: React.FC<AvailabilityPermissionRouteProps> = ({ children }) => {
  const { hasAccess, loading } = useAvailabilityPageAccess();

  if (loading) {
    return (
      <Stack align="center" justify="center" style={{ height: '100%' }}>
        <LoadingOverlay visible top={HEADER_HEIGHT} />
      </Stack>
    );
  }

  if (!hasAccess) {
    return <Navigate to={ROUTES.root} replace />;
  }

  return <>{children}</>;
};

export default AvailabilityPermissionRoute;
